// BULK SEND CV'S ON EMAIL ************************************************************************
// pathname: /v3/bulk-operation/send/{jobSlug}
// ************************************************************************************************
import { useSwrMutationApi, PostBulkSendCvsOnEmail } from 'src/hooks/useSwrApi';


/**
 * @description Sends the selected CVs to the selected applicants on email.
 * - If all applicants are selected, use the 'buildListByStatus' parameter (back-end will ignore the 'slugs' array).
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param successCallback - callback function to be executed on success
 *
 * @example
 * // send CVs to all applicants with status 'interview' (3)
 * const { data, trigger } = useSwrBulkSendCvsOnEmail(jobSlug, 'ro');
 * trigger({ buildListByStatus: 3, emails: ['email1', 'email2'] });
 *
 * // send CVs to selected applicants
 * trigger({ slugs: ['slug1', 'slug2'], emails: ['email1', 'email2'] });
 */
export const useSwrBulkSendCvsOnEmail = (jobSlug: string, locale: string = 'ro', successCallback?: () => void) => {
  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<undefined, PostBulkSendCvsOnEmail>({
    url: `/v3/bulk-operation/send/${jobSlug}`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
